// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"442":"css/app.6855","2556":"css/admin-app.6855"}[chunkId] + ".css";
};